import { useEffect, useState } from 'react'
import { fetchBrainSettings } from '@/api/brainSettings'
import { DEFAULT_CLUSTER_PULL, DEFAULT_LINK_DISTANCE } from '@/components/ui/art/engines/brain'
import type { BrainSettings } from '@/types/brainSettings'

const DEFAULTS: BrainSettings = { cluster_pull: DEFAULT_CLUSTER_PULL, link_distance: DEFAULT_LINK_DISTANCE }

/**
 * The admin-tuned brain drawing, or null while it loads — callers hold their
 * placeholder rather than drawing the brain once with defaults and again with
 * the real values. A failed fetch falls back to the defaults: a display setting
 * is never a reason to withhold the brain.
 */
export function useBrainSettings(): BrainSettings | null {
  const [settings, setSettings] = useState<BrainSettings | null>(null)

  useEffect(() => {
    let active = true
    fetchBrainSettings()
      .then((res) => active && setSettings(res.data.data))
      .catch(() => active && setSettings(DEFAULTS))
    return () => {
      active = false
    }
  }, [])

  return settings
}
